import { Typography } from "@mui/material";
import { Table } from "components/layout/tables/Table";
import { T } from "components/util/t";
import { makeStyles } from "components/providers/makeStyles";

const useStyles = makeStyles(theme => ({
    table: {
        "& th, & td": {
            "&:nth-of-type(2), &:nth-of-type(3)": {
                paddingLeft: theme.spacing(2)
            }
        },
        "& tbody td": {
            "&:nth-of-type(1)": {
                width: "100%"
            }
        }
    }
}));

const sortByEventDivisionDateAscending = (a, b) => (a.eventDivision.event.date < b.eventDivision.event.date) ? -1 : ((a.eventDivision.event.date > b.eventDivision.event.date) ? 1 : 0);

export const RankingsBreakdown = ({ results }) => {
    const classes = useStyles();

    return (
        <Table headers={<><th><T x={results.length}>events_(x)</T></th><th><T>Place</T></th><th><T>Points</T></th></>} height="sm" className={classes.table}>
            {[...results].sort(sortByEventDivisionDateAscending).map(result => (
                <tr key={result.id}>
                    <td>
                        <Typography color={result.dropped && "text.secondary"}>
                            {result.eventDivision.event.name}
                        </Typography>
                    </td>
                    <td>
                        <Typography color={result.dropped && "text.secondary"} component={result.dropped && "s"}>
                            {result.place || "-"}
                        </Typography>
                    </td>
                    <td>
                        <Typography color={result.dropped && "text.secondary"} component={result.dropped && "s"}>
                            {result.points.toLocaleString()}
                        </Typography>
                    </td>
                </tr>
            ))}
        </Table>
    );
};
